import { render, staticRenderFns } from "./feature.vue?vue&type=template&id=44b1dda2&scoped=true"
import script from "./feature.vue?vue&type=script&lang=js"
export * from "./feature.vue?vue&type=script&lang=js"
import style0 from "./feature.vue?vue&type=style&index=0&id=44b1dda2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b1dda2",
  null
  
)

export default component.exports